(function ($) {
    "use strict";

    var $doc = $(document),
        $win = $(window);


    // Scroll to top observer
    // ----------------------
    var scrollTopThreshold = 0.3;

    var introObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var visible = entry.isIntersecting && entry.intersectionRatio >= scrollTopThreshold;

            $(document.body)[(visible ? 'remove' : 'add') + 'Class']('scrolled');
        })
    }, {
        root:       null,
        rootMargin: '0px',
        threshold:  scrollTopThreshold
    });

    var introBlock = document.querySelector('#intro');
    if (introBlock) introObserver.observe(introBlock);


    var debounce = function (fn, delay) {
        var timer;

        return function () {
            var self = this;
            var args = arguments;

            window.clearTimeout(timer);

            timer = window.setTimeout(function () {
                fn.apply(self, args);
            }, delay);
        }
    };


    $(document).on('change', 'form [data-toggle="change-submit"]', debounce(function () {
        $(this).closest('form')[0].submit();
    }, 250));


    // Dropdown active class on link
    // -----------------------------
    // $doc.on('show.bs.dropdown', '.dropdown-menu', function (event) {
    //     var $this   = $(this),
    //         $toggle = $(event.relatedTarget);

    //     $this.data('popel.toggle', $toggle);

    //     $toggle.addClass('active');
    // });

    // $doc.on('hide.bs.dropdown', '.dropdown-menu', function () {
    //     var $this   = $(this),
    //         $toggle = $this.data('popel.toggle');

    //     $toggle.removeClass('active');
    // });

})(window.jQuery);
